<app-progress-indicator
  *ngIf="this.propertyState.paginationApiProgress$ | async"
  text="Please wait while we load"
></app-progress-indicator>

<app-primary-filters> </app-primary-filters>
<div #propertyListContainer id="propcards_base" style="overflow-y: auto">
  <!-- Placeholder shown when no properties are available -->

  <ng-container *ngIf="propertyState.noPropertyView$ | async as noPropertyCause">
    <div
      class="d-flex align-items-center justify-content-center flex-column flex-grow-1 pl-1 pl-md-0"
      *ngIf="!searchInProgress && !propertyList && noPropertyCause == 'NO_COVERAGE'"
    >
      <app-area-not-covered></app-area-not-covered>
    </div>

    <div
      class="d-flex align-items-center justify-content-center flex-column flex-grow-1 pl-1 pl-md-0"
      *ngIf="
        !searchInProgress &&
        !propertyList &&
        (noPropertyCause == 'ZOOM_LIMIT_REACHED' ||
          noPropertyCause == 'HIGH_PROPERTY_COUNT' ||
          noPropertyCause == 'NO_PROPERTY')
      "
    >
      <app-property-search-error [type]="noPropertyCause"></app-property-search-error>
    </div>
  </ng-container>

  <div class="list-content" [hidden]="!propertyList">
    <div class="status-bar">
      <div class="property-count">
        <span class="text-success">{{ totalPropertyCount }}</span>
        properties found
      </div>
      <div class="sort-form">
        <mat-form-field class="small-form-field">
          <mat-label>Sort By</mat-label>
          <mat-select (selectionChange)="onSortChange($event)" [(value)]="defaultSort">
            <mat-option *ngFor="let sort of propertySortFields" [value]="sort">
              {{ sort.displayValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 px-2" *ngFor="let property of propertyList; let i = index">
        <div class="list_card" [ngClass]="{ highlighted: property.PMXPropertyId === highLightedId }">
          <div
            class="propinfo_base"
            role="button"
            (keydown.enter)="getDetails(property); $event.stopPropagation()"
            (click)="getDetails(property); $event.stopPropagation()"
            tabindex="10"
          >
            <div class="row mx-0 proplist_imgWrap">
              <p style="color: transparent; position: absolute; top: 0">{{ property.Address }}</p>
              <div class="position-absolute followLink" (click)="followProperty(property); $event.stopPropagation()">
                <button
                  mat-icon-button
                  tabindex="10"
                  name="watch this property"
                  *ngIf="companyName !== 'homehunt' || userType !== 'agent'"
                  aria-label="watch this property"
                >
                  <mat-icon style="color: rgb(169, 169, 169) !important" *ngIf="!property.isFavorite"
                    >favorite_border</mat-icon
                  >
                  <mat-icon class="text-primary" *ngIf="property.isFavorite">favorite</mat-icon>
                </button>
              </div>

              <div
                *ngIf="property.filterStyleClass"
                class="property-badge sale-type"
                [ngClass]="property.filterStyleClass"
              >
                <span *ngIf="property.filterStyleClass == 'listing'">
                  {{ property.Lst_StandardStatus | titlecase }}
                </span>
                <span *ngIf="property?.Lst_RentalYN == 1">
                  For Rent 
                </span>
                <div *ngIf="property.Lst_MlsBoard != 'MREIS'">
                  <span *ngIf="property.filterStyleClass == 'sold'"> Sold </span>
                </div>

                <div *ngIf="property.Lst_MlsBoard == 'MREIS' && property.Lst_StandardStatus == 'Sold'">
                  <span *ngIf="property.filterStyleClass == 'sold'"> Closed </span>
                </div>
                <span *ngIf="property.filterStyleClass == 'distressed' && !property.addUpdatedBadge">
                  <span class="listings">{{ property.Lst_StandardStatus | titlecase }}</span>
                  <span class="distressed">{{
                    property.Lst_speciallistingconditions || property.Fcl_Status | titlecase
                  }}</span>
                </span>
                <span *ngIf="property.filterStyleClass == 'hud' && !property?.addUpdatedBadge">
                  <span class="listings">{{ property.Lst_StandardStatus | titlecase }}</span>
                  <span class="hud"> {{ property.Lst_speciallistingconditions | titlecase }} </span>
                </span>

                <span *ngIf="!property.Lst_StandardStatus && !property.saletype">
                  <span class="offMarket"> Off Market </span>
                </span>
                <span *ngIf="property.addUpdatedBadge">
                  <span class="listings">{{ property?.Lst_StandardStatus | titlecase }}</span>
                  <span [ngClass]="property?.filterStyleClass">{{ property?.addUpdatedBadge | titlecase }}</span>
                </span>

                <span
                  class="distressed"
                  *ngIf="!property.Lst_speciallistingconditions && !property.Lst_StandardStatus && property.saletype"
                >
                  {{ property.saletype }}
                </span>
              </div>
              <div *ngIf="property.isFeatured" class="property-badge featured">Featured</div>
              <img
                class="img-fluid mx-auto"
                [src]="
                  listingImageBaseUrl + '?ListingId=' + (property.Lst_ListingId || 'null') + '&imageName=1&height=219'
                "
              />
            </div>
            <div class="row my-3 mx-0">
              <div class="col-lg-12 col-12">
                <div class="mt-0 propinfo_value float-left">
                  <p *ngIf="property.filterStyleClass == 'sold'">
                    ${{ (property.CurrentAVMValue | number) || ' N/A' }}
                  </p>
                  <p *ngIf="property?.Lst_RentalYN == 1">
                    ${{ (property.Lst_ListPrice | number) + '/month'|| ' N/A' }}  
                  </p>
                  <p *ngIf="(property.filterStyleClass != 'sold' || (property.Lst_StandardStatus && property.saletype)) && property.filterStyleClass != 'nonFiltered' && property.Lst_RentalYN !== 1">
                    ${{ (property.Lst_ListPrice | number) || 'N/A' }}
                  </p>
                </div>
                <div *ngIf="!property.Lst_StandardStatus && !property.saletype" class="propinfo_value float-right">
                  <p><span>Estimated </span>${{ property.CurrentAVMValue | number }}</p>
                </div>
                <div
                  class="mt-0 rebate float-right"
                  *ngIf="
                    property.isRebateAvailable &&
                    (property.Lst_StandardStatus === 'Active' ||
                      property.Lst_StandardStatus === 'Active Under Contract' ||
                      property.Lst_StandardStatus === 'Pending')
                  "
                >
                  <span *ngIf="property.rebateAmount"
                    >${{ property.rebateAmount | number }} <span>Cash Back</span></span
                  >
                  <span *ngIf="!property.rebateAmount">Cash Back Available</span>
                </div>
              </div>
              <div class="my-0 ml-2 mt-1">
                <div class="d-inline-block propinfo_amntis">
                  <p>
                    <b>{{ property.PropertyType === 'Land' ? '--' : property.BedroomsTotal }}</b>
                    <small *ngIf="property.PropertyType !== 'Land'"> Bed</small>
                  </p>
                </div>
                <div class="d-inline-block propinfo_amntis">
                  <p>
                    <b>{{ property.PropertyType === 'Land' ? '--' : property.BathroomsTotalInteger }}</b>
                    <small *ngIf="property.PropertyType !== 'Land'"> Bath</small>
                  </p>
                </div>
                <div class="d-inline-block propinfo_amntis">
                  <p>
                    <b>{{ property.PropertyType === 'Land' ? '--' : (property.LivingArea | number) }}</b>
                    <small *ngIf="property.PropertyType !== 'Land'"> Sqft</small>
                  </p>
                </div>
                <div class="d-inline-block propinfo_amntis">
                  <p>
                    <b>{{ property.LotSizeSquareFeet | number }}</b
                    ><small> Sqft.lot </small>
                  </p>
                </div>
              </div>
              <div class="col-lg-12 col-12 mt-1">
                <p class="prop_name" [title]="property.Address">{{ property.Address }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      #listPaginator
      class="hide-label center"
      hidePageSize="true"
      showFirstLastButtons
      [length]="
        (listState.isPaginatedResult$ | async)
          ? (propertyState.propertyCount$ | async)?.totalRecord
          : propertyState.listPropertySetValue?.length
      "
      [pageIndex]="((listState.pagination$ | async)?.pageNumber || 1) - 1"
      [pageSize]="(listState.pagination$ | async).pageSize"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>

  <app-company-footer [uniqueMlsList]="uniqueMlsList"></app-company-footer>

  <!-- Property List Sheet Open/Close toggle button -->
  <div class="row prop_dtls_closeBtn pull-right pl-3" *ngIf="mobileQuery.matches" (click)="close()">
    <img src="../assets/images/backArrow.svg" />
  </div>
</div>
